"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomApiService = void 0;
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const FunctionUtil_1 = require("../../base/storyV2/function/FunctionUtil");
class CustomApiService {
    constructor(authStore, brainClient) {
        this.authStore = authStore;
        this.brainClient = brainClient;
    }
    async sendRequest(apiData, input, variableList = []) {
        if ((0, is_blank_1.default)(apiData.url)) {
            return Promise.reject("url is blank");
        }
        let url = FunctionUtil_1.FunctionUtil.customApiUrlReplace(input, apiData.url, variableList);
        const headers = FunctionUtil_1.FunctionUtil.customApiHeadersReplace(input, this.authStore.state.brainToken, this.authStore.state.guestToken, apiData.headerList, variableList);
        let bodyParam = FunctionUtil_1.FunctionUtil.customApiBodyParamsReplace(input, apiData.bodyParam, variableList);
        return this.request(url ?? "", apiData.method ?? "get", headers, bodyParam);
    }
    async request(url, method, headers, body, identityInfo) {
        return this.brainClient.global.request(url, method, headers, body, FunctionUtil_1.FunctionUtil.createAbortUuid(identityInfo));
    }
}
exports.CustomApiService = CustomApiService;
